import { ProductsColTrendsetter } from '../ProductsColTrendsetter'
import { ProductsCol } from './ProductsTable'

export const ProductsColWrapper = () => {
  const domainName = window.location.hostname.split('.')[0]
  const isTrendsetterDomain = domainName === 'trendsetter'

  if (isTrendsetterDomain) {
    return <ProductsColTrendsetter />
  }

  return <ProductsCol />
}
